import { MDBCol, MDBContainer } from 'mdb-react-ui-kit'
import React from 'react'
import { useNavigate } from 'react-router';

const RelatedProducts = () => {
    const navigate = useNavigate();

    const handleClick = (data) => {
        navigate(data); // Replace with your route
    };
    return (
        <>
            <MDBContainer className="lp_revenue p-0">
                <MDBCol size='12' className='text-center my-5'>
                    <h2 className='mb-3'>Related Products</h2>
                    <hr className='py-2' />
                    <div className='mt-4 mb-2'>

                        <button outline className='lp_btn lp_outlinbtn me-3' onClick={() => handleClick('/easymembr')}>
                            Member Management Software
                        </button>
                        <button outline className='lp_btn lp_outlinbtn me-3' onClick={() => handleClick('/easybook')}>
                            Class Management Software
                        </button>
                        {/* <button outline className='lp_btn lp_outlinbtn me-3' onClick={()=>handleClick('/easylead)}>
                            Lead Management Software
                        </button>
                        <button outline className='lp_btn lp_outlinbtn mt-3' onClick={handleClick}>
                            Studio Management Software
                        </button> */}

                    </div>
                </MDBCol>


            </MDBContainer>
        </>
    )
}

export default RelatedProducts
